import {
  Content,
  Title,
  InputFormTable,
  Editor,
  HtmlContent,
} from 'components';
import { stringToMoneyFormat } from 'utils';
import styles from '../styles';

const SalesInformation = ({ data }) => {
  const getValue = (data, property) => {
    if (!data) return '';

    if (property === 'type') {
      if (data.type === 'DELIVERY') {
        return '일반상품';
      } else if (data.type === 'RENTAL') {
        return '렌탈상품';
      } else if (data.type === 'AMOUNT') {
        return '금액권';
      } else {
        return '정기배송';
      }
    } else if (property === 'product_status') {
      if (data.product_status === 'WAIT') {
        return '판매대기';
      } else if (data.product_status === 'SOLDOUT') {
        return '품절';
      } else if (data.product_status === 'NORMAL') {
        return '판매';
      } else if (data.product_status === 'STOP') {
        return '판매중지';
      } else if (data.product_status === 'END') {
        return '판매종료';
      }
    } else if (property === 'product_category') {
      return data[property].product_category_name;
    } else if (property === 'packaging_method') {
      if (data.packaging_method === 'REFRIGERATION') {
        return '냉장';
      } else if (data.packaging_method === 'FREEZING') {
        return '냉동';
      } else if (data.packaging_method === 'GENERAL') {
        return '일반';
      }
    } else if (property === 'tax_type') {
      if (data.tax_type === 'TAXABLE') {
        return '과세';
      } else if (data.tax_type === 'EXEMPT') {
        return '면세';
      } else if (data.tax_type === 'ZERO_RATED') {
        return '영세';
      }
    } else if (property === 'product_policy') {
      return data?.product_policy.filter(
        (p) => p.policy_type === 'GENERAL'
      )?.[0];
    } else {
      return data[property];
    }
  };
  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <Title style={{ ...styles.subTitle }}>판매 정보</Title>
      <InputFormTable
        labelWidth={160}
        form={[
          {
            label: '상품 유형',
            styles: {
              label: {},
            },
            form: [{ input: <span>{getValue(data, 'type')}</span> }],
          },
          {
            label: '상품명',
            form: [{ input: <span>{getValue(data, 'product_name')}</span> }],
          },
          {
            label: '판매 상태',
            form: [
              {
                input: <span>{getValue(data, 'product_status')}</span>,
              },
            ],
          },
          {
            label: '상품 분류',
            direction: 'column',
            form: [
              {
                input: <span>{getValue(data, 'product_category')}</span>,
                fullscreen: true,
              },
            ],
          },
          {
            label: '상품 수량',
            form: [
              {
                input: <span>{getValue(data, 'num')} EA</span>,
              },
            ],
          },
          {
            label: '상품 금액',
            form: [
              {
                input: (
                  <span>{stringToMoneyFormat(getValue(data, 'price'))} 원</span>
                ),
              },
            ],
          },
          {
            label: '할인/적립금',
            form: [
              {
                input: (
                  <div
                    style={{ display: 'flex', flexDirection: 'column', gap: 5 }}
                  >
                    {getValue(data, 'product_policy') ? (
                      <>
                        <span>
                          할인 :{' '}
                          {stringToMoneyFormat(
                            getValue(data, 'product_policy')?.discount_rate
                          )}{' '}
                          {getValue(data, 'product_policy')?.discount_type ===
                          'W'
                            ? '원'
                            : '%'}
                        </span>
                        <span>
                          최대 할인 금 :{' '}
                          {stringToMoneyFormat(
                            getValue(data, 'product_policy')?.max_discount_price
                          )}{' '}
                          원
                        </span>
                        <span>
                          적립 :{' '}
                          {stringToMoneyFormat(
                            getValue(data, 'product_policy')?.reserve_rate
                          )}{' '}
                          {getValue(data, 'product_policy')?.reserve_type ===
                          'W'
                            ? '원'
                            : '%'}
                        </span>
                      </>
                    ) : (
                      <span>설정되어 있지 않음.</span>
                    )}
                  </div>
                ),
              },
            ],
          },
          {
            label: '상품 코드',
            form: [
              {
                input: <p>{getValue(data, 'product_code')}</p>,
              },
            ],
          },
          {
            label: '포장 방식',
            form: [
              {
                input: <span>{getValue(data, 'packaging_method')}</span>,
              },
            ],
          },
          {
            label: '과세 방식',
            form: [
              {
                input: <span>{getValue(data, 'tax_type')}</span>,
              },
            ],
          },
          {
            label: '과세율',
            form: [
              {
                input: <span>{getValue(data, 'tax_rate')} %</span>,
              },
            ],
          },
          {
            label: '상품내용',
            form: [
              {
                input: (
                  <div
                    style={{
                      // width: '100%',
                      width: '950px',
                      height: '720px',
                      margin: '0 auto',
                      overflow: 'auto',
                    }}
                  >
                    <HtmlContent content={getValue(data, 'product_content')} />
                  </div>
                ),
              },
            ],
          },

          {
            label: '자동구매확정일',
            form: [
              {
                input: (
                  <span>
                    {getValue(data, 'auto_confirm')
                      ? `${getValue(data, 'auto_confirm')}일 후`
                      : '자동확정'}
                  </span>
                ),
              },
            ],
          },
        ]}
      />
    </Content>
  );
};

export default SalesInformation;
